import { render, staticRenderFns } from "./RewardShop.vue?vue&type=template&id=7880a492&scoped=true"
import script from "./RewardShop.vue?vue&type=script&lang=js"
export * from "./RewardShop.vue?vue&type=script&lang=js"
import style0 from "./RewardShop.vue?vue&type=style&index=0&id=7880a492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880a492",
  null
  
)

export default component.exports